// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6c37bc3b","488":"fa3e5667"}[chunkId] + ".chunk.js";
};